<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-12 col-sm-6 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <!-- <model-select :options="data_marketing" placeholder="Select Marketing"
                      v-model="this.currentData.id_marketing" style="z-index:500" :isError="marketingCek">
                    </model-select> -->
                    <multi-select :options="needData1" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label>Date <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="currentData.tanggal" class="picker" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Shift <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      
                      <model-select :options="needData2" :settings="{ settingOption: value, settingOption: value }"
                              v-model="currentData.shift_id" class="custom-width form-control" placeholder="" ></model-select>
                    </div>
                  </div>
                </div> -->

                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label>Amount<span class="text-danger">*</span></label>
                    <input type="text" id="additional" v-model="currentData.task_amount" @input="formatCurrency('task_amount', currentData.task_amount)" placeholder="Rp.0,-">
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label>Notes<span class="text-danger">*</span></label>
                    <textarea type="text" v-model="currentData.task_name" rows="2" placeholder=""></textarea>
                  </div>
                </div>
                

                <!-- <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <multi-select :options="needData1" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div> -->
                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Save</button>
                  <router-link to="other_deduction" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-group input[type="datetime-local"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="time"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="datetime-local"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}

.form-group input[type="time"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch, rupiahInput, rupiahoutput } from "@/assets/js/function";
import { ModelSelect, MultiSelect } from 'vue-search-select';


export default {
  components: {

    ModelSelect,
    MultiSelect

  },
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Insert Other Deduction",
      title1: "add new Other Deduction",
      namaCompany: '',
      config: "",
      api: "",
      value: "",

      //data
      currentData: {
        tanggal: new Date(),
        // shift_id: null,
        // jam_masuk: '',
        // jam_keluar: '',

      },
      currentDate: new Date,
      needData1: [],
      needData2: [],

      ///multi select
      locations: [],
      employees: [],

      lastSelectItemLocation: {},
      lastSelectItemEmployee: {},
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'insert')

    this.namaCompany = localStorage.getItem('namaCompany');

    this.preparedData();
    // this.LocationList.push({ id: 0, value: 0, text: 'SEMUA' });

  },

  watch: {
    "currentData.shift_id"(newIdShift) {
      // Find the selected shift's jam_masuk from needData2
      const selectedShift = this.needData2.find(
        (item) => item.value === newIdShift
      );
      if (selectedShift) {
        // Update the clock-in time with the selected shift's jam_masuk
        // this.currentData.jam_masuk = selectedShift.text.match(/\(([^-]*)/)[1].trim(); // Extracts jam_masuk
        
        const shiftTimes = selectedShift.text.match(/\(([^-]*) - ([^)]*)\)/);
        if (shiftTimes) {
          this.currentData.jam_masuk = shiftTimes[1].trim(); // Set jam_masuk
          this.currentData.jam_keluar = shiftTimes[2].trim(); // Set jam_keluar
        }
      }
    },
  },
  
  methods: {

    formatCurrency(name) {
        this.currentData[name] = rupiahInput(this.currentData[name]);
    },

    preparedData() {

      const needData1 = JSON.parse(localStorage.getItem('employeeList'));

      needData1.forEach((item, index) => {
        // const item_prepare = { value: item.id, text: item.nama + ' (' + item.telepon + ')' };
        const item_prepare = { value: item.id, text: item.nama };
        this.needData1.push(item_prepare);
      });

   
      this.employees = [];



    },
    onSelectLocations(items, lastSelectItem) {
      this.locations = items
      this.lastSelectItemLocation = lastSelectItem
    },
    onSelectEmployees(items, lastSelectItem) {
      this.employees = items
      this.lastSelectItemEmployee = lastSelectItem
    },


    formatDateLocal(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    },
    
    async insert() {
      let formData = new FormData();
      appendForm(formData)

     
      
      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.delete('task_amount')
      formData.append('task_amount', rupiahoutput(this.currentData.task_amount))

      formData.delete("tanggal");
      formData.append("tanggal", this.formatDateLocal(this.currentData.tanggal));

      
      let employee_id = [];
      this.employees.forEach((item, index) => {
        employee_id.push(item.value)
      });

      formData.append('employee_id', employee_id.join(','));

      for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
      }
      // CloseLoading(); return;

      

      const api = base_url + '/v3/otherdeduction/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
        AlertBottom(data.message);
        goPage('other_deduction');
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

    },

  },

};
</script>
